'use es6';

import { Record } from 'immutable';
export default Record({
  amount: null,
  currencyCode: null
});